import { useEffect, useRef } from 'react';
var PRELOAD_MAX_AGE = 5 * 60 * 1000; // 5 mins
var TIME_TO_INTENT = 200;
export function usePressablePreloadRef(_ref) {
  var load = _ref.load,
    onLoad = _ref.onLoad,
    onBeforeLoad = _ref.onBeforeLoad;
  var ref = useRef(null);
  useEffect(function () {
    var el = ref.current;
    if (!el) {
      return;
    }
    var request = {};
    var clearPreloadTimeouts = function clearPreloadTimeouts() {
      if (typeof request.preloadIntentTimeout === 'number') {
        clearTimeout(request.preloadIntentTimeout);
        delete request.preloadIntentTimeout;
      }
      if (typeof request.preloadMaxAgeTimeout === 'number') {
        clearTimeout(request.preloadMaxAgeTimeout);
        delete request.preloadMaxAgeTimeout;
      }
    };
    var cancelPreload = function cancelPreload() {
      var _request$preload;
      clearPreloadTimeouts();
      (_request$preload = request.preload) === null || _request$preload === void 0 || _request$preload.dispose();
    };
    var loadReference = function loadReference() {
      var _request$preload$refe, _request$preload2;
      if (request.load) {
        return request.load;
      }
      var reference = (_request$preload$refe = (_request$preload2 = request.preload) === null || _request$preload2 === void 0 ? void 0 : _request$preload2.reference) !== null && _request$preload$refe !== void 0 ? _request$preload$refe : load();
      if (request.preload) {
        delete request.preload;
      }
      request.load = {
        reference: reference,
        dispose: function dispose() {
          reference.dispose();
          delete request.load;
        }
      };
      return request.load;
    };
    var clickListener = function clickListener() {
      clearPreloadTimeouts();
      if (onBeforeLoad) {
        onBeforeLoad();
      }
      onLoad(loadReference());
    };
    var mouseDownListener = function mouseDownListener() {
      clearPreloadTimeouts();
      loadReference();
    };
    var preloadReference = function preloadReference() {
      if (request.preloadIntentTimeout || request.preload) {
        return;
      }
      request.preloadIntentTimeout = setTimeout(function () {
        delete request.preloadIntentTimeout;
        var reference = load();
        request.preload = {
          reference: reference,
          dispose: function dispose() {
            reference.dispose();
            delete request.preload;
          }
        };
        request.preloadMaxAgeTimeout = setTimeout(function () {
          var _request$preload3;
          delete request.preloadMaxAgeTimeout;
          (_request$preload3 = request.preload) === null || _request$preload3 === void 0 || _request$preload3.dispose();
        }, PRELOAD_MAX_AGE);
      }, TIME_TO_INTENT);
    };
    el.addEventListener('click', clickListener);
    el.addEventListener('mousedown', mouseDownListener);
    el.addEventListener('mouseenter', preloadReference);
    el.addEventListener('mouseleave', cancelPreload);
    return function () {
      cancelPreload();
      el.removeEventListener('click', clickListener);
      el.removeEventListener('mousedown', mouseDownListener);
      el.removeEventListener('mouseenter', preloadReference);
      el.removeEventListener('mouseleave', cancelPreload);
    };
  }, [load, onBeforeLoad, onLoad]);
  return ref;
}